const SIGNATURE_EMPTY_VALUE = '';

const createStringSignature = (input: string): string => {
	if (!input) {
		return SIGNATURE_EMPTY_VALUE;
	}

	return `${input[0]}${input.length}${input[input.length - 1]}`;
};

const convertAnyToSignature = (input: any): string => {
	switch (typeof input) {
		case 'string':
			return `${input.length}${createStringSignature(input)}`;
		case 'number':
			return `${input}`;
		case 'boolean':
			return input ? '1' : '0';
		case 'object':
			if (Array.isArray(input)) {
				return `[${input.length}]`;
			} else if (input instanceof Date) {
				return `Date(${input.getTime()})`;
			} else if (input) {
				try {
					return `{${Object.keys(input).length}}`;
				} catch (err) {
					return input ? `$${JSON.stringify(input)}` || SIGNATURE_EMPTY_VALUE : SIGNATURE_EMPTY_VALUE;
				}
			}
			return SIGNATURE_EMPTY_VALUE;
		default:
			break;
	}

	return SIGNATURE_EMPTY_VALUE;
};

export const generateSignature = (...args: any[]): string => {
	return args
		.map(convertAnyToSignature)
		.join('')
		.replace(/\s/g, '');
};
